/* Elico PDP buy box V3 — all behaviour for sections/pdp-buybox-universal-v3.liquid.
   Reads per-section config from the <script type="application/json" data-ebbv3-config>
   island; the section contains NO inline JS (2026-07-23 incident: Liquid whitespace
   trims inside inline JS killed the buy box).
   SINGLE add-to-cart owner: one-time AND subscribe adds happen here, including the
   refill subscription lines (selling plan from [data-cadence]) and the free-refill
   discount code (config.subDiscountCode). assets/elico-sub-discount.js stays inert on
   this template because the hooks are data-vtype / data-ebb-atc-v3. */
(function () {
  'use strict';
  if (window.__ebbv3Loaded) return;
  window.__ebbv3Loaded = true;

  var PAGE_LANG = document.documentElement.getAttribute('lang') || 'nb-NO';

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Palo Alto cart drawer = <cart-element id="cart-drawer">; getCart() re-renders from
     the live cart, openCartDrawer() slides it open. Fall back to /cart if absent. */
  function openCartDrawer() {
    var routes = routesRoot();
    var drawer = document.querySelector('cart-element#cart-drawer, cart-element, [data-cart-drawer]');
    if (drawer && typeof drawer.getCart === 'function') {
      var open = function () {
        try {
          if (typeof drawer.openCartDrawer === 'function') { drawer.openCartDrawer(); }
          else if (typeof drawer.open === 'function') { drawer.open(); }
        } catch (e) { window.location.href = routes + 'cart'; }
      };
      try {
        var p = drawer.getCart();
        if (p && typeof p.then === 'function') { p.then(open, open); } else { open(); }
      } catch (e) { open(); }
      return;
    }
    window.location.href = routes + 'cart';
  }

  function refreshDrawer() {
    var drawer = document.querySelector('cart-element#cart-drawer, cart-element, [data-cart-drawer]');
    if (drawer && typeof drawer.getCart === 'function') { try { drawer.getCart(); } catch (e) {} }
  }

  /* ───────────────────────────── buy box ───────────────────────────── */
  function initBuybox(cfgEl) {
    var sectionId = cfgEl.getAttribute('data-ebbv3-config');
    var root = document.querySelector('[data-section-id="' + sectionId + '"]');
    if (!root) return;

    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[ebbv3] config parse failed, using DOM fallbacks', e); }

    var strings = cfg.strings || {};
    var variants = Array.isArray(cfg.variants) ? cfg.variants : [];
    var moneySample = String(cfg.moneySample || '').replace(/<[^>]*>/g, '').trim();
    var currencyDigits = (typeof cfg.currencyDigits === 'number') ? cfg.currencyDigits : 0;
    var moneySym = moneySample.replace(/[0-9\s., ]/g, '') || 'kr';
    var symIsPrefix = /^[^0-9]/.test(moneySample) && moneySample.indexOf(moneySym) === 0;
    var QTY_DISCOUNT = (cfg.qtyDiscount && typeof cfg.qtyDiscount === 'object') ? cfg.qtyDiscount : { 1: 0, 2: 0.15, 3: 0.15 };
    var REFILL_VARIANT_IDS = Array.isArray(cfg.refillVariantIds) ? cfg.refillVariantIds : [];
    var SUB_DISCOUNT_CODE = cfg.subDiscountCode || '';
    var EBB_WAITLIST = !!cfg.waitlist;
    /* self-subscribe (refill products): subscribing adds THIS product's variant with the
       chosen selling plan; PLAN_PRICES holds the real per-delivery price per variant/plan
       so the display always matches what Appstle charges */
    var SELF_SUB = !!cfg.selfSub;
    var PLAN_PRICES = (cfg.planPrices && typeof cfg.planPrices === 'object') ? cfg.planPrices : {};

    var vidInput = root.querySelector('[data-variant-id]');
    var state = {
      variantId: cfg.initialVariantId || (vidInput && parseInt(vidInput.value, 10)) || 0,
      qty: 1,
      option1: cfg.initialOption1 || null,
      type: cfg.initialType || 'once' // 'sub' | 'once' — drives the cart logic
    };

    function formatMoney(cents) {
      var amount = cents / 100;
      var s = amount.toLocaleString(PAGE_LANG, { minimumFractionDigits: currencyDigits, maximumFractionDigits: currencyDigits });
      return symIsPrefix ? (moneySym + ' ' + s) : (s + ' ' + moneySym);
    }
    function currentVariant() {
      for (var i = 0; i < variants.length; i++) { if (variants[i].id === state.variantId) return variants[i]; }
      return variants[0];
    }

    /* self-subscribe: the real per-delivery price for the current variant + chosen cadence,
       or null when not in self-sub mode / not subscribing */
    function selfSubUnitPrice() {
      if (!SELF_SUB || state.type !== 'sub') return null;
      var cad = root.querySelector('[data-cadence]');
      var plan = cad && cad.value;
      var pp = PLAN_PRICES[String(state.variantId)];
      return (pp && plan && typeof pp[plan] === 'number') ? pp[plan] : null;
    }

    function recompute() {
      var v = currentVariant();
      if (!v) return;
      var unit = v.price;
      var compareUnit = v.compare_at_price || 0;
      var fullUnit = (compareUnit > unit) ? compareUnit : unit;
      var lineFull = fullUnit * state.qty;
      var lineNow, showWas;
      var subUnit = selfSubUnitPrice();
      if (subUnit !== null) {
        /* subscribing to this product: plan price per unit; the one-time qty deals
           (e.g. 3-for-2 BXGY) are one-time-only, so the qty map does NOT apply */
        lineNow = Math.round(subUnit * state.qty);
        showWas = lineFull > lineNow;
      } else {
        var disc = QTY_DISCOUNT[state.qty] || 0;
        lineNow = Math.round(unit * state.qty * (1 - disc));
        showWas = (disc > 0) || (compareUnit > unit);
      }
      root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = formatMoney(lineNow); });
      root.querySelectorAll('[data-compare]').forEach(function (el) {
        if (showWas && lineFull > lineNow) { el.textContent = formatMoney(lineFull); el.style.display = ''; }
        else { el.style.display = 'none'; }
      });
      if (vidInput) vidInput.value = state.variantId;
      /* [ELICO OOS] tell elico-oos.js which variant is selected (sold-out ATC/waitlist swap + ETA) */
      document.dispatchEvent(new CustomEvent('elico:variant', { detail: { sectionId: sectionId, variantId: state.variantId } }));
      var q = root.querySelector('[data-quantity]'); if (q) q.value = state.qty;
    }

    /* ── gallery: hero/thumb sync ── */
    var heroEl = root.querySelector('[data-hero]');
    function markActive(idx) {
      root.querySelectorAll('[data-slide]').forEach(function (s) { s.classList.toggle('is-active', +s.dataset.index === idx); });
      root.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', +t.dataset.thumb === idx);
        if (+t.dataset.thumb === idx) { t.scrollIntoView({ inline: 'nearest', block: 'nearest' }); }
      });
      root.querySelectorAll('[data-rail-thumb]').forEach(function (t) { t.classList.toggle('is-active', +t.dataset.railThumb === idx); });
      root.querySelectorAll('[data-slide] video').forEach(function (v) {
        var onActive = (+v.closest('[data-slide]').dataset.index === idx);
        if (onActive) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
        else { try { v.pause(); } catch (e) {} }
      });
    }
    function showSlide(idx) {
      markActive(idx);
      var slide = root.querySelector('[data-slide][data-index="' + idx + '"]');
      if (!slide) return;
      if (heroEl && getComputedStyle(heroEl).overflowX !== 'visible') {
        heroEl.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      var deskScroll = root.querySelector('.ebb__hero-wrap');
      if (deskScroll && getComputedStyle(deskScroll).overflowY !== 'visible') {
        deskScroll.scrollTo({ top: slide.offsetTop, behavior: 'smooth' });
        root.querySelectorAll('[data-rail-thumb]').forEach(function (t) { t.classList.toggle('is-active', +t.dataset.railThumb === idx); });
      }
    }
    function showMediaId(id) {
      var slides = root.querySelectorAll('[data-slide]');
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(id)) { showSlide(+slides[i].dataset.index); return; }
      }
    }
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showSlide(+t.dataset.thumb); });
    });
    if (heroEl) {
      var heroScrollTimer;
      heroEl.addEventListener('scroll', function () {
        window.clearTimeout(heroScrollTimer);
        heroScrollTimer = window.setTimeout(function () {
          markActive(Math.round(heroEl.scrollLeft / heroEl.clientWidth));
        }, 60);
      }, { passive: true });
    }

    /* desktop rail */
    var slides = root.querySelectorAll('[data-slide]');
    var railThumbs = root.querySelectorAll('[data-rail-thumb]');
    var scrollEl = root.querySelector('.ebb__hero-wrap');
    function setRailActive(idx) {
      railThumbs.forEach(function (t) {
        t.classList.toggle('is-active', +t.dataset.railThumb === idx);
        if (+t.dataset.railThumb === idx) { t.scrollIntoView({ block: 'nearest' }); }
      });
    }
    railThumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = +t.dataset.railThumb;
        var slide = root.querySelector('[data-slide][data-index="' + idx + '"]');
        if (slide && scrollEl) { scrollEl.scrollTo({ top: slide.offsetTop, behavior: 'smooth' }); }
        setRailActive(idx);
      });
    });
    if ('IntersectionObserver' in window && slides.length && scrollEl) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) setRailActive(+e.target.dataset.index); });
      }, { root: scrollEl, rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      slides.forEach(function (s) { io.observe(s); });
    }

    /* ── variant swatches ── */
    root.querySelectorAll('[data-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var val = sw.getAttribute('data-value');
        root.querySelectorAll('[data-swatch]').forEach(function (x) { x.classList.remove('is-selected'); });
        sw.classList.add('is-selected');
        state.option1 = val;
        for (var i = 0; i < variants.length; i++) { if (variants[i].option1 === val) { state.variantId = variants[i].id; break; } }
        if (sw.dataset.mediaId) showMediaId(sw.dataset.mediaId);
        recompute();
      });
    });

    /* ── rating → smooth-scroll to reviews (custom #reviews section or Loox widget) ── */
    function findReviewsTarget() {
      var el = document.querySelector('#reviews');
      if (el) return el;
      el = document.querySelector('#looxReviews, .loox-reviews, [id^="looxReviews"], [data-loox-reviews], .loox-container');
      if (el) return el.closest('.shopify-section') || el;
      var secs = document.querySelectorAll('.shopify-section');
      for (var i = 0; i < secs.length; i++) {
        if (secs[i].querySelector('[id*="loox" i], [class*="loox" i]') &&
            !secs[i].querySelector('[class*="rating" i], [class*="snippet" i]')) {
          return secs[i];
        }
      }
      return null;
    }
    root.querySelectorAll('[data-scroll-reviews]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = findReviewsTarget();
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });

    /* ── ingredients drawer ── */
    var ingDrawer = root.querySelector('[data-ingredients-drawer]');
    function openIngredients() {
      if (!ingDrawer) return;
      ingDrawer.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { ingDrawer.classList.add('is-open'); });
    }
    function closeIngredients() {
      if (!ingDrawer) return;
      ingDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(function () { ingDrawer.hidden = true; }, 300);
    }
    root.querySelectorAll('[data-open-ingredients]').forEach(function (b) { b.addEventListener('click', openIngredients); });
    if (ingDrawer) {
      ingDrawer.querySelectorAll('[data-close-ingredients]').forEach(function (b) { b.addEventListener('click', closeIngredients); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ingDrawer.classList.contains('is-open')) closeIngredients(); });
    }

    /* ── quantity tiers — REAL quantity, cap 3 ── */
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-qty]').forEach(function (x) { x.classList.remove('is-selected'); });
        b.classList.add('is-selected');
        state.qty = Math.min(parseInt(b.getAttribute('data-qty'), 10) || 1, 3);
        recompute();
      });
    });

    /* ── subscribe ⇄ one-time toggle (data-vtype, NOT data-type — keeps elico-sub-discount.js inert) ── */
    root.querySelectorAll('[data-ss]').forEach(function (o) {
      o.addEventListener('click', function () {
        root.querySelectorAll('[data-ss]').forEach(function (x) { x.classList.remove('is-selected'); });
        o.classList.add('is-selected');
        state.type = o.getAttribute('data-vtype');
        recompute(); /* self-sub mode shows the plan price when subscribing */
      });
    });
    var cadenceEl = root.querySelector('[data-cadence]');
    if (cadenceEl) { cadenceEl.addEventListener('change', recompute); }

    /* ── sticky ATC ── shows only once the real ATC has scrolled PAST the top of the viewport (same rule as bundle/1-year) */
    var atcBtn = root.querySelector('.ebb__atc');
    var sticky = root.querySelector('[data-sticky]');
    /* [ELICO OOS] observe the ATC wrapper (ATC + waitlist button, one always visible) so the
       sticky bar keeps working while the ATC itself is hidden for a sold-out variant */
    var stickyAnchor = root.querySelector('.ebb__atc-wrap') || atcBtn;
    if (atcBtn && sticky) {
      var updateSticky = function () {
        var r = stickyAnchor.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        sticky.classList.toggle('is-hidden', r.bottom > 0);
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { sticky.classList.toggle('is-hidden', e[0].isIntersecting || !(e[0].boundingClientRect.top < 0)); }, { threshold: 0 }).observe(stickyAnchor);
      } else {
        window.addEventListener('scroll', updateSticky, { passive: true });
      }
      window.addEventListener('resize', updateSticky, { passive: true });
      updateSticky();
    }
    var stickyBtn = root.querySelector('[data-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var main = root.querySelector('[data-ebb-atc-v3]');
        if (main) main.click();
      });
    }

    /* ── ADD TO CART — single owner for BOTH paths ──
       one-time: kit at chosen qty.
       subscribe: kit (one-time) + 1 of EACH in-stock refill scent with the chosen
       selling plan, then the free-refill discount code is applied. */
    var form = root.querySelector('#ebbv3-form');
    var addingNow = false;
    var codeApplied = false;

    /* Fire-and-forget: sets the discount cookie via the /discount/CODE redirect.
       NEVER awaited before the cart add — the redirect downloads a full page and
       blocking on it made the add feel ~3s slow. Pre-warmed on load (below) so the
       cookie is usually already set by the time the customer clicks ATC. */
    function applyDiscountCode() {
      if (!SUB_DISCOUNT_CODE || codeApplied) return Promise.resolve();
      return fetch(routesRoot() + 'discount/' + encodeURIComponent(SUB_DISCOUNT_CODE), { credentials: 'same-origin' })
        .then(function () { codeApplied = true; })
        .catch(function () {});
    }

    function doAdd(triggerBtn) {
      if (addingNow) return;
      addingNow = true;
      var btn = triggerBtn || atcBtn;
      if (btn) { btn.setAttribute('disabled', 'disabled'); btn.setAttribute('aria-busy', 'true'); }
      var done = function () { addingNow = false; if (btn) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-busy'); } };

      var items;
      var cadenceSel = root.querySelector('[data-cadence]');
      var wantsSub = (state.type === 'sub' && cadenceSel && cadenceSel.value);
      var isSub = false; /* starterkit flow: kit + separate refill subscription lines */
      if (wantsSub && SELF_SUB) {
        /* refill products: subscribe to THIS variant with the chosen plan */
        items = [{ id: state.variantId, quantity: state.qty, selling_plan: cadenceSel.value }];
      } else if (wantsSub && REFILL_VARIANT_IDS.length) {
        isSub = true;
        items = [{ id: state.variantId, quantity: state.qty }];
        REFILL_VARIANT_IDS.forEach(function (rid) { items.push({ id: rid, quantity: 1, selling_plan: cadenceSel.value }); });
      } else {
        items = [{ id: state.variantId, quantity: state.qty }];
      }

      /* discount code (starterkit free-refill flow only) runs in PARALLEL with the add */
      var codePromise = isSub ? applyDiscountCode() : Promise.resolve();
      fetch(routesRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, d: d }; });
      }).then(function (res) {
        done();
        if (res.ok) {
          openCartDrawer();
          if (isSub) { codePromise.then(function () { setTimeout(refreshDrawer, 250); }); }
        } else {
          console.warn('[ebbv3] add to cart failed', res.d);
          alert((res.d && res.d.description) || strings.atcError || 'Could not add to cart.');
        }
      }).catch(function (err) { done(); console.warn('[ebbv3]', err); });
    }

    /* Pre-warm the discount cookie (parity with the live theme's elico-sub-discount.js):
       when the subscribe option is the active choice, apply the code in the background
       during idle time so the drawer shows the free refill lines instantly on add. */
    if (SUB_DISCOUNT_CODE && !EBB_WAITLIST) {
      var preWarm = function () { if (state.type === 'sub') { applyDiscountCode(); } };
      if ('requestIdleCallback' in window) { requestIdleCallback(preWarm, { timeout: 3000 }); }
      else { setTimeout(preWarm, 1200); }
      root.querySelectorAll('[data-ss][data-vtype="sub"]').forEach(function (o) {
        o.addEventListener('click', function () { applyDiscountCode(); });
      });
    }

    /* [ELICO OOS] always bound — while sold out the ATC is simply hidden (elico-oos.js swaps it
       for the waitlist button and back on variant switch) */
    if (atcBtn && atcBtn.hasAttribute('data-ebb-atc-v3')) {
      atcBtn.addEventListener('click', function (e) { e.preventDefault(); doAdd(atcBtn); });
    }
    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); doAdd(); });
    }

    /* ── waitlist popup + Klaviyo client-side subscribe ── */
    var wlModal = root.querySelector('[data-wl-modal]');
    if (wlModal) {
      var wlFormWrap = wlModal.querySelector('[data-wl-form-wrap]');
      var wlSuccess = wlModal.querySelector('[data-wl-success]');
      var wlForm = wlModal.querySelector('[data-wl-form]');
      var wlError = wlModal.querySelector('[data-wl-error]');
      var wlSubmit = wlModal.querySelector('[data-wl-submit]');
      var wlOpener = null;

      var wlOpen = function () {
        wlOpener = document.activeElement;
        wlModal.hidden = false;
        document.body.style.overflow = 'hidden';
        var first = wlModal.querySelector('#ebb-wl-name') || wlModal.querySelector('#ebb-wl-email');
        if (first) { setTimeout(function () { first.focus(); }, 50); }
      };
      var wlClose = function () {
        wlModal.hidden = true;
        document.body.style.overflow = '';
        if (wlOpener && wlOpener.focus) { wlOpener.focus(); }
      };
      var wlShowError = function (msg) { if (wlError) { wlError.textContent = msg; wlError.hidden = false; } };

      root.querySelectorAll('[data-ebb-waitlist]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); wlOpen(); });
      });
      wlModal.querySelectorAll('[data-wl-close]').forEach(function (b) { b.addEventListener('click', wlClose); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !wlModal.hidden) wlClose(); });

      if (wlForm) {
        wlForm.addEventListener('submit', function (e) {
          e.preventDefault();
          if (wlError) { wlError.hidden = true; }
          var email = (wlForm.querySelector('[name="email"]').value || '').trim();
          var name = (wlForm.querySelector('[name="first_name"]').value || '').trim();
          if (!email || email.indexOf('@') < 1) { wlShowError(strings.wlInvalidEmail || 'Enter a valid email address.'); return; }
          var key = wlModal.getAttribute('data-wl-key');
          var list = wlModal.getAttribute('data-wl-list');
          var src = wlModal.getAttribute('data-wl-source') || 'Waitlist';
          if (!key || !list) { wlShowError(strings.wlNotConfigured || 'The waitlist is not set up yet.'); console.warn('[ebbv3 waitlist] missing Klaviyo key or list id'); return; }

          var profileAttrs = { email: email };
          if (name) { profileAttrs.first_name = name; }
          var payload = { data: { type: 'subscription', attributes: {
            custom_source: src,
            profile: { data: { type: 'profile', attributes: profileAttrs } }
          }, relationships: { list: { data: { type: 'list', id: list } } } } };

          if (wlSubmit) { wlSubmit.setAttribute('aria-busy', 'true'); }
          /* abort after 12s so an ad blocker stalling a.klaviyo.com never wedges the button */
          var wlCtrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
          var wlTimeout = setTimeout(function () { if (wlCtrl) { wlCtrl.abort(); } }, 12000);
          var wlDone = function () { clearTimeout(wlTimeout); if (wlSubmit) { wlSubmit.removeAttribute('aria-busy'); } };
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify(payload),
            signal: wlCtrl ? wlCtrl.signal : undefined
          }).then(function (r) {
            wlDone();
            if (r.ok || r.status === 202) {
              if (wlFormWrap) { wlFormWrap.hidden = true; }
              if (wlSuccess) { wlSuccess.hidden = false; }
            } else {
              r.text().then(function (t) { console.warn('[ebbv3 waitlist] Klaviyo error', r.status, t); });
              wlShowError(strings.wlErrorGeneric || 'Something went wrong.');
            }
          }).catch(function (err) {
            wlDone();
            console.warn('[ebbv3 waitlist] request failed', err);
            wlShowError(strings.wlErrorNetwork || 'We could not sign you up right now.');
          });
        });
      }
    }

    recompute();
  }

  /* ───────────────────── cross-sell quick-add ("Kjøp nå" sheet) ───────────────────── */
  function initCrossSell(root) {
    var sheet = root.querySelector('[data-exs-sheet]');
    if (!sheet) return;
    var els = {
      img: sheet.querySelector('[data-qs-img]'),
      name: sheet.querySelector('[data-qs-name]'),
      price: sheet.querySelector('[data-qs-price]'),
      pills: sheet.querySelector('[data-qs-pills]'),
      variants: sheet.querySelector('[data-qs-variants]'),
      optname: sheet.querySelector('[data-qs-optname]'),
      swatches: sheet.querySelector('[data-qs-swatches]'),
      atc: sheet.querySelector('[data-qs-atc]'),
      atcLabel: sheet.querySelector('[data-qs-atc-label]'),
      atcPrice: sheet.querySelector('[data-qs-atc-price]'),
      pdp: sheet.querySelector('[data-qs-pdp]')
    };
    var TXT = {
      soldout: sheet.getAttribute('data-txt-soldout') || 'Utsolgt',
      added: sheet.getAttribute('data-txt-added') || '✓'
    };
    var current = { variantId: null };
    var defaultAtcLabel = els.atcLabel.textContent;

    function openSheet() { sheet.hidden = false; document.body.style.overflow = 'hidden'; requestAnimationFrame(function () { sheet.classList.add('is-open'); }); }
    function closeSheet() { sheet.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(function () { sheet.hidden = true; }, 300); }

    function selectVariant(v) {
      current.variantId = v.id;
      els.price.textContent = v.price;
      els.atcPrice.textContent = v.price;
      if (v.image) { els.img.src = v.image; }
      els.atc.disabled = !v.available;
      els.atcLabel.textContent = v.available ? defaultAtcLabel : TXT.soldout;
    }

    function fill(data) {
      els.name.textContent = data.title;
      els.price.textContent = data.price;
      els.atcPrice.textContent = data.price;
      els.img.src = data.image || '';
      els.pdp.setAttribute('href', data.url || '#');
      els.pills.innerHTML = '';
      (data.pills || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean).forEach(function (p) {
        var s = document.createElement('span'); s.className = 'exs__sheet-pill'; s.textContent = p; els.pills.appendChild(s);
      });
      var vs = (data.variants || []);
      var multi = vs.length > 1;
      els.swatches.innerHTML = '';
      if (multi) {
        els.variants.hidden = false;
        els.optname.textContent = (data.option_name && data.option_name !== 'Title') ? (data.option_name + ':') : '';
        vs.forEach(function (v, i) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'exs__sw' + (i === 0 ? ' is-active' : '');
          b.innerHTML = '<span class="exs__sw-chip">' + (v.image ? '<img src="' + v.image + '" alt="">' : '') + '</span><span class="exs__sw-label">' + (v.option1 || v.title) + '</span>';
          b.addEventListener('click', function () {
            els.swatches.querySelectorAll('.exs__sw').forEach(function (x) { x.classList.remove('is-active'); });
            b.classList.add('is-active'); selectVariant(v);
          });
          els.swatches.appendChild(b);
        });
      } else {
        els.variants.hidden = true;
      }
      selectVariant(vs[0] || { id: null, price: data.price, available: true });
    }

    root.querySelectorAll('[data-open-quick]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = btn.getAttribute('data-open-quick');
        var dataEl = root.querySelector('[data-quick-data="' + id + '"]');
        if (!dataEl) return;
        try { fill(JSON.parse(dataEl.textContent)); } catch (err) { return; }
        openSheet();
      });
    });
    sheet.querySelectorAll('[data-exs-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet(); });

    function refreshAndOpenDrawer() {
      var drawer = document.querySelector('cart-element#cart-drawer, cart-element, [data-cart-drawer]');
      if (drawer && typeof drawer.getCart === 'function') {
        try { drawer.getCart(); } catch (e) {}
        setTimeout(function () {
          try {
            if (typeof drawer.openCartDrawer === 'function') { drawer.openCartDrawer(); }
            else if (typeof drawer.open === 'function') { drawer.open(); }
          } catch (e) { window.location.href = routesRoot() + 'cart'; }
        }, 450);
        return;
      }
      try {
        var evt = (window.theme && window.theme.PUB_SUB_EVENTS && window.theme.PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
        if (typeof window.publish === 'function') { window.publish(evt, { source: 'elico-cross-sell' }); return; }
      } catch (e) {}
      window.location.href = routesRoot() + 'cart';
    }

    els.atc.addEventListener('click', function () {
      if (!current.variantId) { return; }
      els.atc.disabled = true;
      fetch(routesRoot() + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: current.variantId, quantity: 1 }] })
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      }).then(function (res) {
        if (!res.ok) {
          els.atcLabel.textContent = (res.data && res.data.description) ? res.data.description : TXT.soldout;
          setTimeout(function () { els.atcLabel.textContent = defaultAtcLabel; els.atc.disabled = false; }, 1800);
          return;
        }
        els.atcLabel.textContent = TXT.added;
        closeSheet();
        refreshAndOpenDrawer();
        setTimeout(function () { els.atcLabel.textContent = defaultAtcLabel; els.atc.disabled = false; }, 800);
      }).catch(function () { els.atc.disabled = false; els.atcLabel.textContent = defaultAtcLabel; });
    });

    /* desktop prev/next scroll arrows */
    (function () {
      var rowEl = root.querySelector('.exs__row');
      var prevB = root.querySelector('[data-exs-prev]');
      var nextB = root.querySelector('[data-exs-next]');
      if (!rowEl || !nextB) return;
      function step() { var c = rowEl.querySelector('.exs__card'); return c ? Math.round(c.getBoundingClientRect().width + 12) : Math.round(rowEl.clientWidth * 0.6); }
      function update() {
        var max = rowEl.scrollWidth - rowEl.clientWidth - 1;
        if (max <= 2) { if (prevB) prevB.hidden = true; nextB.hidden = true; return; }
        if (prevB) { prevB.hidden = false; prevB.disabled = rowEl.scrollLeft <= 2; }
        nextB.hidden = false; nextB.disabled = rowEl.scrollLeft >= max;
      }
      if (prevB) prevB.addEventListener('click', function () { rowEl.scrollBy({ left: -step(), behavior: 'smooth' }); });
      nextB.addEventListener('click', function () { rowEl.scrollBy({ left: step(), behavior: 'smooth' }); });
      rowEl.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', function () { window.requestAnimationFrame(update); });
      update();
    })();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  ready(function () {
    document.querySelectorAll('[data-ebbv3-config]').forEach(initBuybox);
    /* cross-sell roots live inside the v3 section; init only the [data-exs-root] whose
       section also has a v3 config island (avoids double-binding if a legacy section
       ever coexists on the same page) */
    document.querySelectorAll('[data-exs-root]').forEach(function (rootEl) {
      var section = rootEl.closest('[data-section-id]');
      var sid = section && section.getAttribute('data-section-id');
      if (sid && document.querySelector('[data-ebbv3-config="' + sid + '"]')) { initCrossSell(rootEl); }
    });
  });
})();
